import { createFileRoute, redirect } from "@tanstack/react-router"
import BlogHomePage from "~/components/Blog/BlogHomePage"
import MarketingLayout from "~/layouts/MarketingLayout"
import { z } from "zod"

const blogSearchSchema = z.object({
  tag: z.string().optional().default("all-tags"),
})

export const Route = createFileRoute("/blog/")({
  validateSearch: blogSearchSchema,
  beforeLoad: ({ search }) => {
    // Redirect to /blog?tag=all-tags if no tag is provided
    if (!search.tag) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router uses non-Error throw for control flow
      throw redirect({
        to: "/blog",
        search: { tag: "all-tags" },
      })
    }
  },
  component: Blog,
})

function Blog() {
  const { tag } = Route.useSearch()

  return (
    <MarketingLayout>
      <BlogHomePage
        tag={tag}
        posts={{ docs: [], totalDocs: 0, totalPages: 0, page: 1 }}
        categories={[]}
        currentPage={1}
      />
    </MarketingLayout>
  )
}
